import { Button } from 'devextreme-react/button';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import DataGrid, { Column, Paging } from 'devextreme-react/data-grid';
import { useCallback, useContext, useState } from 'react';
import { FileTypes, KindOfOrder } from '../../../../types/enums';
import { FileAttachmentLink, FileAttachmentsPopup } from '../../../common';
import { RefetchScope, RetailOrderContext } from '../context/RetailOrderContext';

export default function RetailOrderFiles(props: {
	fileTypes: FileTypes[],
	defaultFileType?: FileTypes,
	buttonCaption?: string,
	closeOnUpload?: boolean,
	replaceFile?: boolean,
	onFileAdded?: (fileType: FileTypes) => void
}
) {

	const { order, refetchOrder } = useContext(RetailOrderContext);
	const [isPopupVisible, setPopupVisibility] = useState(false);

	const closeOnUpload = props.closeOnUpload ?? true;

	const rowPrepared = useCallback((e: any) => {
		if (e.rowType === "data") {
			if (e.data.fromLinkedOrder) {
				e.rowElement.classList.add("linked-order-document");
			}
		}
	}, []);

	return (
		<>
			{
				!!props.buttonCaption &&
				<>
					<Toolbar className='button-toolbar'>
						<Item location={'before'} >
							<Button
								elementAttr={{ 'data-testid': 'btn-upload-file' }}
								text={props.buttonCaption}
								icon="Inscyth-Add"
								onClick={() => setPopupVisibility(true)}>
							</Button>
						</Item>
					</Toolbar>

					<FileAttachmentsPopup
						attachedFiles={order.details.files}
						orderID={order.details.retailOrderID}
						parentGuid={order.details.guid}
						kindOfOrder={KindOfOrder.RetailOrder}
						orderTypeID={order.details.roTypeID}
						defaultFileType={props.defaultFileType}
						fileTypeFilter={(fileType: FileTypes) => {
							if (fileType === FileTypes.DisplayPhoto) return true;
							return props.fileTypes && props.fileTypes.includes(fileType);
						}}
						useFileTypes={true}
						onFileAdded={(fileType: FileTypes) => {
							refetchOrder(RefetchScope.Files);

							if (props.onFileAdded) {
								props.onFileAdded(fileType);
							}

							if (props.fileTypes.includes(fileType) && closeOnUpload) {
								setPopupVisibility(false);
							}
						}}
						onFileDeleted={() => refetchOrder(RefetchScope.Files)}
						onPopupHidden={() => setPopupVisibility(false)}
						visible={isPopupVisible}
						replaceFile={props.replaceFile}
						hideDeleteButton={true}
					/>
				</>
			}

			<DataGrid
				className='dx-card wide-card'
				dataSource={order.details.files.filter(x => props.fileTypes.includes(x.fileTypeID))}
				allowColumnResizing={true}
				showBorders={true}
				showColumnLines={true}
				columnAutoWidth={true}
				keyExpr={'documentID'}

				onRowPrepared={rowPrepared}
			>
				<Paging enabled={false} />

				<Column
					caption={'File Name'}
					dataType="string"
					cellRender={(cell: any) => {
						return <FileAttachmentLink
							caption={cell.data.fileName}
							fileName={cell.data.fileName}
							awsS3Key={cell.data.awsS3Key} />
					}}
				>
				</Column>
				<Column
					dataField={'fileTypeName'}
					caption={'File Type'}
					dataType="string"
				/>
				<Column
					dataField={'uploadDate'}
					caption={'Upload Date'}
					dataType="date"
					format="shortDateShortTime"
				/>
				<Column
					dataField={'createdBy'}
					caption={'Created By'}
					dataType="string"
				/>
			</DataGrid>
		</>
	);
}
